import { get, set, values, orderBy, filter, forEach, cloneDeep } from 'lodash'
import { createSelector } from 'reselect'
import moment from 'moment'

import { makeGetSalesEventType } from '../EventType/selector'

function isAfterBusinessDate(event) {
  const now = moment()
  const eventStart = moment(event.startTime)
  const businessStart = moment().startOf('day').add(3, 'hours')

  if (now.hours() < 3) {
    businessStart.subtract(1, 'day')
  }

  return eventStart.isAfter(businessStart)
}

function isBeforeBusinessDate(event) {
  return !isAfterBusinessDate(event)
}

export const getSalesEvents = (state) => {
  const getSalesEventType = makeGetSalesEventType()
  const events = cloneDeep(values(get(state, 'event.byId')))

  forEach(events, (event) => {
    const allowLockToggle = isAfterBusinessDate(event)
    const eventType = getSalesEventType(state, event.salesEventTypeId)
    set(event, 'eventType', eventType)
    set(event, 'allowLockToggle', allowLockToggle)
  })

  return orderBy(events, 'startTime', 'asc')
}

const getSalesEvent = (state, eventId) => {
  const getSalesEventType = makeGetSalesEventType()
  const event = get(state, `event.byId.${eventId}`, {})

  const allowLockToggle = isAfterBusinessDate(event)
  const eventType = getSalesEventType(state, event.salesEventTypeId)
  set(event, 'eventType', eventType)
  set(event, 'allowLockToggle', allowLockToggle)

  return event
}

export const makeGetSalesEvent = () => createSelector([getSalesEvent], (event) => event)

export const makeGetFutureSalesEvents = () => createSelector(
  [getSalesEvents],
  (salesEvents) => {
    const result = filter(salesEvents, isAfterBusinessDate)
    return result
  }
)

export const makeGetPreviousSalesEvents = () => createSelector(
  [getSalesEvents],
  (salesEvents) => {
    const result = orderBy(filter(salesEvents, isBeforeBusinessDate), 'startTime', 'desc')
    return result
  }
)

export const getFilters = (state) => get(state, 'event.filter', {})

export const getIsSalesEventLoading = state => state?.event?.isLoading ?? false
